module.exports = __webpack_public_path__ + "static/media/AG.a6fbf543.png";